const {
  PAGE_BODY_CLASSES,
  getPageBodyClass,
} = require("./src/utils/pageBodyClass");

const updateBodyClass = (pathname) => {
  const bodyClass = getPageBodyClass(pathname);

  for (const className of PAGE_BODY_CLASSES) {
    document.body.classList.toggle(className, className === bodyClass);
  }
};

exports.onClientEntry = () => {
  updateBodyClass(window.location.pathname);
};

exports.onPreRouteUpdate = ({ location }) => {
  updateBodyClass(location.pathname);
};
